class VariantMediaGallery extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    const mapScript = document.getElementById(`VariantMediaData-${this.sectionId}`);
    this.variantMediaMap = mapScript ? JSON.parse(mapScript.textContent) : {};
    subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
  }

  handleVariantChange(event) {
    const selectedVariantId = event.data?.variant?.id?.toString();
    if (selectedVariantId && this.variantMediaMap[selectedVariantId]) {
      const newMedia = this.variantMediaMap[selectedVariantId];
      this.updateGalleries(newMedia.desktop, newMedia.mobile);
    }
  }

  updateGalleries(desktopImages, mobileImages) {
    // Mobile slider
    const mobileGalleryList = this.querySelector(`#Slider-Gallery-Mobile-${this.sectionId}`);
    if (mobileGalleryList) {
      this.renderGallery(mobileGalleryList, mobileImages, 'mobile');
      const sliderComponent = mobileGalleryList.closest('slider-component');
      const sliderDotsContainer = this.querySelector(`#SliderDots-Mobile-${this.sectionId}`);
      if (sliderComponent && sliderDotsContainer) {
        if (this.currentSliderListener) {
          sliderComponent.removeEventListener('slideChanged', this.currentSliderListener);
        }
        const newListener = (event) => {
          this.syncDotsBySlider(sliderDotsContainer, event.detail.currentPage - 1);
        };
        sliderComponent.addEventListener('slideChanged', newListener);
        this.currentSliderListener = newListener;
        setTimeout(() => {
          sliderComponent.resetPages?.();
          sliderComponent.setSlidePosition?.(0);
          this.updateSliderDots(sliderDotsContainer, mobileImages.length);
          mobileGalleryList.querySelector('.slider__slide')?.classList.add('is-active');
        }, 20);
      }
    }

    // Desktop standard grid
    const desktopGalleryGrid = this.querySelector('.product-gallery-grid');
    if (desktopGalleryGrid) {
      this.renderGallery(desktopGalleryGrid, desktopImages, 'desktop');
    }

    // Desktop air-fryer new layout (thumbnails at bottom)
    const mainImageContainer = this.querySelector('.product-gallery-new-layout .main-image-container');
    const thumbnailsSidebar = this.querySelector('.product-gallery-new-layout .gallery-thumbnails-sidebar');
    if (mainImageContainer || thumbnailsSidebar) {
      this.renderNewLayout(mainImageContainer, thumbnailsSidebar, desktopImages);
      document.dispatchEvent(new CustomEvent('variant-gallery-updated'));
    }
  }

  syncDotsBySlider(container, currentIndex) {
    container.querySelectorAll('.slider-dot').forEach((btn, index) => {
      btn.classList.toggle('is-active', index === currentIndex);
      btn.setAttribute('aria-current', index === currentIndex ? 'true' : 'false');
    });
  }

  updateSliderDots(container, totalSlides) {
    container.innerHTML = '';
    const allDotButtons = [];
    for (let i = 0; i < totalSlides; i++) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
      btn.classList.add('slider-dot');
      if (i === 0) { btn.classList.add('is-active'); btn.setAttribute('aria-current', 'true'); }
      btn.addEventListener('click', () => {
        const sliderComponent = container.closest('slider-component');
        if (sliderComponent?.setSlidePosition) {
          sliderComponent.setSlidePosition(i * sliderComponent.sliderItemOffset);
          allDotButtons.forEach(b => { b.classList.remove('is-active'); b.removeAttribute('aria-current'); });
          btn.classList.add('is-active');
          btn.setAttribute('aria-current', 'true');
        }
      });
      allDotButtons.push(btn);
      container.appendChild(btn);
    }
  }

  renderNewLayout(mainContainer, thumbContainer, mediaItems) {
      if (mainContainer) {
        mainContainer.innerHTML = '';
        mediaItems.forEach((mediaHtml, index) => {
          const div = document.createElement('div');
          div.className = `main-gallery-item${index === 0 ? ' active' : ''}`;
          div.dataset.index = index;
          div.innerHTML = `<div class="product-media-container">${mediaHtml}</div>`;
          mainContainer.appendChild(div);
        });
      }
      if (thumbContainer) {
        thumbContainer.innerHTML = '';
        mediaItems.forEach((mediaHtml, index) => {
          const div = document.createElement('div');
          div.className = `thumbnail-item${index === 0 ? ' active' : ''}`;
          div.dataset.index = index;
          div.innerHTML = mediaHtml;
          thumbContainer.appendChild(div);
        });
      }
    }

    // Inside VariantMediaGallery class

    renderGallery(container, mediaItems, type) { // Renamed 'images' to 'mediaItems' for clarity
        container.innerHTML = ''; 
        const isMobileSlider = type === 'mobile';

        // Loop through the data array (which contains pre-rendered HTML strings)
        mediaItems.forEach((mediaHtml, index) => { 
            
            // NO MORE: dynamic creation of <img> tag. We assume mediaHtml is the full <picture> or <div>/video tag.
            
            if (isMobileSlider) {
                // Recreate the <li> structure for the mobile slider
                const listItem = document.createElement('li');
                
                // NOTE: Ensure your Liquid JSON provides the data-media-id if needed for MediaGallery synchronization!
                
                listItem.className = `product__media-item grid__item slider__slide${index === 0 ? ' is-active' : ''}`;
                listItem.id = `Slide-Mobile-${this.sectionId}-${index}`;
                
                // 💥 FIX: Insert the pre-rendered HTML (image or video) directly
                listItem.innerHTML = mediaHtml; 
                container.appendChild(listItem);
            } else {
                // Recreate the <div> structure for the desktop grid
                const divItem = document.createElement('div');
                
                // The class/structure must match your Liquid desktop rendering
                divItem.className = `gallery-item gallery-item--${index}`;
                
                // 💥 FIX: Insert the pre-rendered HTML (image or video) directly
                divItem.innerHTML = mediaHtml; 
                container.appendChild(divItem);
            }
        });
    }
}

customElements.define('variant-media-gallery', VariantMediaGallery);